// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const FlagKidsFilled = (props: SVGProps<SVGSVGElement>) => (
	<svg width="1em" height="1em" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			d="M73.704 22.956c.378-4.406.754-9.058 1.13-13.956 0 .136-13.575 5.175-23.656 3.378-15.123-1.702-24.5-2.73-32.634 4.276a5.086 5.086 0 0 0-5.24-2.68 5.064 5.064 0 0 0-3.314 1.995 5.047 5.047 0 0 0-.934 3.749l9.64 63.986A5.07 5.07 0 0 0 20.4 86.77 5.087 5.087 0 0 0 23.69 88a5.067 5.067 0 0 0 4.073-2.05 5.05 5.05 0 0 0 .935-3.75l-4.423-29.338a4.098 4.098 0 0 1 2.235-4.296c3.28-1.62 7.86-3.123 12.975-3.966 7.124-1.299 15.285-1.322 22.416-1.494C80.504 42.886 85.547 31.172 87 28.056c-4.43-.684-8.863-2.558-13.296-5.1Z"
			fill="#fff"
		/>
	</svg>
);
export default FlagKidsFilled;
